<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦平台侵权处理规则</div>
    <div class="main_item">
      <p>
        第一条
        为了维护神州邦邦平台公平、和谐的商业氛围，推动服务交易的繁荣，保障买卖双方的合法权益，维护神州邦邦平台的正常运营秩序，根据《神州邦邦平台服务协议》及《神州邦邦平台服务规则》，制定本制度。
      </p>
    </div>
    <div class="main_item">
      <p>第二条 神州邦邦平台侵权行为管理制度适用于神州邦邦平台上的所有用户。</p>
    </div>
    <div class="main_item">
      <p>第三条 侵权行为</p>
      <ul class="content_wrap1">
        <li>
          <p>
            本制度所指的侵权行为是指用户在神州邦邦平台从事的经营活动侵犯他人（包括但不限于神州邦邦平台用户）的姓名权、名称权、名誉权、肖像权、荣誉权、商标权、专利权、著作权、商业秘密等任何合法权益的行为。
          </p>
        </li>
        <li>
          <p>范围</p>
          <ul class="content_wrap2">
            <li>
              <p>
                侵犯姓名权行为：采用盗用、冒用等方式侵犯其他自然人姓名权的行为。
              </p>
            </li>
            <li>
              <p>
                侵犯名称权行为：采用盗用、冒用等方式侵犯其他法人、个体工商户、个人合伙名称的行为。
              </p>
            </li>
            <li>
              <p>
                侵犯名誉权行为：采用侮辱、诽谤等方式侵犯其他自然人和法人名誉的行为。
              </p>
            </li>
            <li>
              <p>
                侵犯肖像权行为：未经本人同意，以盈利为目的使用其他自然人肖像的行为。
              </p>
            </li>
            <li>
              <p>
                侵犯荣誉权行为：采用盗用、冒用等方式侵犯其他自然人和法人荣誉的行为。
              </p>
            </li>
            <li>
              <p>
                侵犯商标权行为：未经商标注册人的许可，使用与他人注册商标相同或相近似的商标等行为。
              </p>
            </li>
            <li>
              <p>
                侵犯专利权行为：采用假冒他人专利等方式侵犯法人专利权的行为。
              </p>
            </li>
            <li>
              <p>侵犯著作权行为：</p>
              <p>1、未经著作权人许可，发表其作品的；</p>
              <p>
                2、未经合作作者许可，将与他人合作创作的作品当作自己单独创作的作品发表的；
              </p>
              <p>3、没有参加创作，为谋取个人名利，在他人作品上署名的；</p>
              <p>4、歪曲、篡改他人作品的；</p>
              <p>5、剽窃他人作品的；</p>
              <p>6、法律法规规定的其他侵犯他人著作权的行为。</p>
            </li>
            <li>
              <p>
                侵犯商业秘密行为：未经商业秘密所有人同意，使用或披露他方商业秘密，或者通过不正当途径获取他方商业秘密并使用或披露等行为。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>第四条 维权具体措施和步骤如下：</p>
      <p>一、权利请求</p>
      <ul class="content_wrap1">
        <li>
          <p>任何个人或单位如果同时符合以下两个条件：</p>
          <ul class="content_wrap2">
            <li>
              <p>是某一信息的权利所有人；</p>
            </li>
            <li>
              <p>神州邦邦平台上的信息侵犯了该主体的权利。</p>
            </li>
          </ul>
          <p>
            请上述个人或单位务必联系神州邦邦平台工作人员，按照神州邦邦平台工作人员的提示提供证明材料。
          </p>
        </li>
        <li>
          <p>
            为了有效处理上述个人或单位的权利请求，请使用以下格式（包括各条款的序号）：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                请提供具体的联络信息，包括姓名、身份证或护照复印件（对自然人）、营业执照复印件（对单位）、通信地址、电话号码、传真和电子邮件；
              </p>
            </li>
            <li>
              <p>请完整、准确地指明涉嫌侵权行为的网页地址；</p>
            </li>
            <li>
              <p>
                请提供构成侵权的初步证明材料，谨此提示如以下材料可能会构成初步证明：
              </p>
              <p>（1） 由人民法院出具的对侵权事实认定的判决书；</p>
              <p>
                （2）
                由国家商标局、版权局等机构颁发的对涉嫌遭受侵权权利的权属证明；
              </p>
              <p>
                （3）对涉嫌遭受侵权内容的相关源文件或创作交易经过材料，包括但不限于协议合同、转账凭证、沟通记录等；
              </p>
              <p>（4）对涉嫌侵权事实的举证。</p>
            </li>
            <li>
              <p>
                在该权利通知落款处亲笔签名，如果是依法成立的机构或组织，请加盖公章。
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <p>二、反请求</p>
      <p>
        神州邦邦平台在收到前述请求及证明材料后将通知涉嫌侵权的所有人／管理人，并断开相关链接或者删除相关内容，被断开链接的网页的所有权人／管理人和相关内容的发布者可以在申诉期内向神州邦邦平台发出相关内容不侵犯他方权利的反请求。反请求发出后，神州邦邦平台对收到的反请求内容向前述请求人予以转达并告知可以向有关主管部门投诉或者向人民法院起诉，在十五日内未收到前述请求人再次投诉／起诉的，可以恢复相关内容，但不对该恢复行为及恢复后的相关内容承担法律责任。
      </p>
      <ul class="content_wrap1">
        <li>
          <p>
            提出反请求的个人或单位务必联系神州邦邦平台工作人员，按照神州邦邦平台工作人员的提示提供证明材料。
          </p>
        </li>
        <li>
          <p>
            为了有效处理上述个人或单位的反请求，请使用以下格式（包括各条款的序号）：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                请提供具体的联络信息，包括姓名、身份证或护照复印件（对自然人）、单位登记证明复印件（对单位）、通信地址、电话号码、传真和电子邮件；
              </p>
            </li>
            <li>
              <p>请完整、准确地指明要求恢复的事项；</p>
            </li>
            <li>
              <p>
                请提供不构成侵权的初步证明材料，谨此提示如下材料可能会构成初步证明：
              </p>
              <p>（1） 由人民法院出具的对侵权事实不予认定的判决书；</p>
              <p>
                （2）由国家商标局、版权局等机构颁发的对被指控侵权客体的权属证明
                ；
              </p>
              <p>
                （3）对被指控侵权客体的相关源文件或创作交易经过材料，包括但不限于协议合同、转账凭证、沟通记录等；
              </p>
              <p>（4）其他对指控侵权作品的举证。</p>
            </li>
            <li>
              <p>
                在该权利通知落款处亲笔签名，如果是依法成立的机构或组织，请加盖公章。
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <p>
        三、权利主张方应对各自的“权利请求”或者“反请求”的陈述真实性负责，如陈述失实，权利主张方将承担由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。
      </p>
      <p>
        四、被举报方在7天内收到多次举报，并且多次举报为同一内容的情况下，视为一次举报。
      </p>
    </div>
    <div class="main_item">
      <p>第五条 神州邦邦平台的权利和义务</p>
      <p>一、神州邦邦平台有义务接受投诉，并对涉嫌的侵权行为进行调查和说明。</p>
      <p>二、神州邦邦平台有权利要求权利主张方提供证明材料。</p>
      <p>
        三、神州邦邦平台有权根据单方认定的侵权情节采用警告、限期整改、删除侵权内容、清退等方式进行处理，情节严重者可移交司法机关处理，细节如下：
      </p>
      <ul class="content_wrap1">
        <li>
          <p>
            若工程师的行为被认定为非原创、一稿多卖等侵犯知识产权类行为，网站都有权对工程师处以限制经营7天，扣除500元保证金（若有）的处理；情节严重者将处以直接清退并扣除全部保证金。已产生交易的，本网站经判定支持全额退款给雇主，并按雇主实际损失金额扣除保证金进行赔付。
          </p>
        </li>
        <li>
          <p>
            若工程师的行为被认定侵犯除知识产权外其他人身权利的，本网站有权及时制止工程师并处以限制经营7天，扣除500元保证金的处理，收到警告未及时整改或情节严重的，本网站有权对工程师处以直接清退，并扣除全部保证金的处理，且保留追溯其侵权责任的权利。
          </p>
        </li>
      </ul>
      <p>
        用户因侵权行为造成的一切经济损失由用户自行承担，本网站将不承担任何法律责任。
      </p>
      <p>
        四、神州邦邦平台因用户侵权行为而遭受损失的，侵权用户应承担赔偿责任（包括但不限于处理此侵权事件所支出的律师费、差旅费等）。
      </p>
    </div>
    <div class="main_item">
      <p>第六条 附则</p>
      <p>一、本制度自发布之日起生效并执行。</p>
      <p>二、本制度修订权及最终解释权归神州邦邦平台所有。</p>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>